/* src/app/modules/concept/concept/concept-dialog-sales.component.css */
.cds-header-text {
  min-width: 0;
  padding-right: 36px;
}
.cds-error {
  margin: 4px 0 0;
  font-size: 12px;
  color: #b91c1c;
}
/*# sourceMappingURL=concept-dialog-sales.component.css.map */
